import BuildAndQuote from 'build-and-quote/components/BuildAndQuote/BuildAndQuote.jsx';
import BuildAndQuoteProvider from 'build-and-quote/BuildAndQuoteProvider.jsx';

const root = BuildAndQuote;
const provider = BuildAndQuoteProvider;
const main = provider;

export const widgets = {
    BuildAndQuote: {
        components: {
            root,
            provider,
            main,
        },
    },
};

export default {
    root,
    provider,
    BuildAndQuote: main,
};
